import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        bgColor: '#1F1F1F',
        selectColor: '#353739',
        selectStroke: 'rgba(127,127,127,0.2)',
        buttonBluePrimary: '#006AD4',
        buttonGreySecondary: '#7F7F7F',
        newMailFill: '#353739',
        newMailColor: '#7F7F7F',
        senderColor: '#FFFFFF',
        previewColor: '#7F7F7F',
        subjectColor: '#F8FAFC',
    },
    typography: {

    },

    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
                contained: {
                    boxShadow: 'none',
                    backgroundColor: '#006AD4',
                    color: 'white',
                    textTransform: 'none',
                    paddingTop: '16px', paddingBottom: '16px', paddingLeft: '32px', paddingRight: '32px',
                    borderRadius: '8px'
                },
                containedGrey: {
                    backgroundColor: '#353739',
                    color: '#7F7F7F',
                    width: '100%',
                    borderColor: '#7F7F7F',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    paddingTop: '16px', paddingBottom: '16px', paddingLeft: '32px', paddingRight: '32px',
                    borderRadius: '8px'
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    width: '100%',
                    marginBottom: '2rem',
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: '#353739',
                        color: 'white',
                        '& fieldset': {
                            borderColor: '#353739',
                        },
                        '&:hover fieldset': {
                            borderColor: 'white',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'white',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: 'white',
                    },
                },
            },
        },

    }
});

export default theme;
